import { Headphones, Heart, Pause, Play } from "lucide-react";
import { Link } from "react-router-dom";
import { usePlayer } from "../context/PlayerContext";
import { genreName } from "../lib/presets";
import { Cover, EqBars } from "./Cover";
import { AuthorLink } from "./AuthorLink";

export const SongCard = ({ song, list, index = 0 }) => {
  const { current, playing, play } = usePlayer();
  const active = current?.id === song.id;
  return (
    <div data-testid={`song-card-${song.id}`} className="group rise" style={{ animationDelay: `${index * 40}ms` }}>
      <div className="relative aspect-square rounded-2xl overflow-hidden border border-[var(--c-line)]">
        <Cover song={song} className="w-full h-full transition-transform duration-500 group-hover:scale-105" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        <button data-testid={`song-card-play-${song.id}`} onClick={() => play(song, list)}
          className={`absolute bottom-3 right-3 w-12 h-12 rounded-full bg-[var(--c-orange)] text-white flex items-center justify-center glow-orange transition-[opacity,transform] duration-300 ${
            active ? "opacity-100" : "opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0"}`}>
          {active && playing ? <Pause className="w-5 h-5" fill="currentColor" /> : <Play className="w-5 h-5 ml-0.5" fill="currentColor" />}
        </button>
        {song.genre && <span className="absolute top-3 left-3 text-[10px] uppercase tracking-wider font-semibold px-2 py-1 rounded-md bg-black/60 backdrop-blur text-zinc-200">{genreName(song.genre)}</span>}
      </div>
      <Link to={`/daina/${song.id}`} data-testid={`song-card-link-${song.id}`} className="block mt-3">
        <p className="font-semibold truncate flex items-center gap-2 hover:text-[var(--c-orange)] transition-colors">{active && playing && <EqBars />}{song.title}</p>
      </Link>
      <AuthorLink song={song} className="block text-xs text-zinc-500 truncate" />
      <div className="flex gap-3 mt-1.5 text-xs text-zinc-500">
        <span className="flex items-center gap-1"><Headphones className="w-3 h-3" />{song.plays}</span>
        <span className="flex items-center gap-1"><Heart className="w-3 h-3" fill={song.liked ? "currentColor" : "none"} />{song.likes}</span>
      </div>
    </div>
  );
};
